import styles from "../../../styles/Participant-Employment.module.css"
import { Dropdown } from "primereact/dropdown"
import { checkErrorValidation } from "./formikAux"
const DropdownField = ({
  label,
  value,
  setValue,
  options,
  valueName,
  error,
  required,
  size,
  callback,
  filter,
}) => {
  return (
    <>
      <div
        className={styles.field}
        style={{ marginBottom: "0rem", width: `${size ? size : "100"}%` }}
      >
        <label
          className={`${styles.label} ${required && styles.requiredField}`}
          style={{ marginBottom: "0rem" }}
        >
          {label}
        </label>
        <Dropdown
          style={{ width: "100%" }}
          options={options}
          value={value}
          optionLabel={"name"}
          optionValue={"code"}
          showClear
          filter={filter}
          onChange={(e) => {
            valueName
              ? setValue(valueName, e.target.value)
              : setValue(e.target.value)
            if (callback) {
              callback()
            }
          }}
          className={`${styles.education_dropdown} ${
            checkErrorValidation(error) ? "p-invalid" : ""
          }`}
        />
        {checkErrorValidation(error) && error}
      </div>
    </>
  )
}
export default DropdownField
